import React, { useRef, useState } from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { Column } from '@xingternal/xing-grid';

import { ExternalUrlDescription } from '@/graphql/generated';

import { LoadingPlaceholder } from '../loading-placeholder';
import { onIframeLoad } from './helpers/iframe';

import styles from './external-url-description.css';

type Props = {
  description: ExternalUrlDescription;
} & WrappedComponentProps;

const ExternalURLDescription: React.FC<Props> = ({ description, intl }) => {
  const [isLoading, setLoadingState] = useState(true);
  const iframeRef = useRef(null);

  const onLoad = (): void => {
    setLoadingState(false);
    onIframeLoad(iframeRef);
  };

  return (
    <Column size={12} className={styles.iframeWrapper}>
      {isLoading && <LoadingPlaceholder testId="external-url-description-loading" />}
      <iframe
        height={0}
        ref={iframeRef}
        data-testid="posting-description-iframe"
        className={styles.iframe}
        src={description.proxyUrl}
        onLoad={onLoad}
        title={intl.formatMessage({ id: 'JOBS_DETAIL_DESCRIPTION_TITLE' })}
      />
    </Column>
  );
};

export const ExternalURLDescriptionComponent = injectIntl(ExternalURLDescription);
